export default {"src":"/_next/static/media/ArrowDown2.97de4f93.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};